import { useNavigate } from "react-router-dom";


const NotificationTableRow = ({ notification }) => {
    const navigate = useNavigate();

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    // Truncate description if too long
    const truncateText = (text, maxLength = 80) => {
        if (!text) return "-";
        return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    };

    return (
        <tr>
            <td>{notification.title || "-"}</td>
            <td>{truncateText(notification.description)}</td>
            <td>{notification.total_recipients ?? "-"}</td>
            <td>{formatDate(notification.created_at)}</td>

            <td>
                <button
                    size="sm"

                    onClick={() =>
                        navigate(`/organization/notification/${notification.batch_id}`)
                    }
                    style={{
                        backgroundColor: "black",
                        color: "white",
                        border: "none",
                        padding: "5px 20px",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                >
                    View
                </button>
            </td>
        </tr>
    );
};

export default NotificationTableRow;
